import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getSupplierStatsAction } from '../../../modules/statistics/Actions';
import Stats from './Stats';
import getLangData from '../../../utils/getLangData';
import AdBanner from '../../ads/AdBanner';
import { Col, Row } from 'reactstrap';
import {
  supplierProductsIsLoadingSelector,
  supplierProductsSelector
} from '../../../modules/myProductList/Supplier/Selectors';
import { supplierDataSelector } from '../../../modules/auth/Selectors';
import ProductComp from '../../UI/combine/ProductComp';
import { Link } from 'react-router-dom';
import { getMySupplierPrivateInquiriesAction } from '../../../modules/myInquiries/Supplier/Private/Actions';
import {
  supplierPrivateInquiriesIsLoadingSelector,
  supplierPrivateInquiriesSelector
} from '../../../modules/myInquiries/Supplier/Private/Selectors';
import PrivateInquriyComp from '../../UI/combine/PrivateInquriyComp';
import PublicInquriyComp from '../../UI/combine/PublicInquriyComp';
import {
  supplierPublicInquiriesIsLoadingSelector,
  supplierPublicInquiriesSelector
} from '../../../modules/myInquiries/Supplier/Public/Selectors';
import { getMySuppliersPublicInquiriesAction } from '../../../modules/myInquiries/Supplier/Public/Actions';
import { getMyProductsSuppliersAction } from '../../../modules/myProductList/Supplier/Actions';

const SupplierStaticBar = ({
  currentUser,
  getSupplierStatsAction,
  supplierStats,
  supplierData,
  getSupplierProducts,
  supplierProducts,
  supplierProductsIsLoading,
  privateInquiries,
  privateInquiriesIsLoading,
  getPrivateInquiries,
  getPublicInquiries,
  publicInquiries,
  publicInquiriesIsLoading
}) => {
  const supplierId = supplierData?._id;

  useEffect(() => {
    getSupplierProducts({
      size: 6,
      offest: 0,
      searchTerm: '',
      filterSupplier: supplierId
    });
    // getSupplierProductsPictures();
  }, [getSupplierProducts]);

  useEffect(() => {
    getPrivateInquiries({
      filterSupplierID: supplierId,
      supplierId: supplierId,
      offest: 0,
      size: 6
    });
  }, [getPrivateInquiries]);

  useEffect(() => {
    getPublicInquiries({
      offest: 0,
      size: 6
      // filterCategory: supplierData?.supplierCID[0]
      // url: `public-supplier-inquiry/search-public-inquiries-for-supplier/`
    });
  }, []);
  const statsTranslate = getLangData().stats;
  return (
    <Row>
      <Col sm='12'>
        <ProductComp
          cardTitle={statsTranslate.recently_added_products}
          isLoading={supplierProductsIsLoading}
          items={supplierProducts}
          edit='/my-supplier-products'
        >
          <Link to='/my-supplier-products' className='btn btn-primary'>
            {getLangData().components.actions.view_more}
          </Link>
        </ProductComp>
      </Col>
      {/* <Col lg='6' md='12' sm='12' className='my-3'>
        <PrivateInquriyComp
          showDate={false}
          cardTitle={statsTranslate.recently_added_private_inquiry}
          isLoading={privateInquiriesIsLoading}
          items={privateInquiries}
          edit='/my-private-inquiries-supplier'
        >
          <Link to='/my-private-inquiries-supplier' className='btn btn-primary'>
            {getLangData().components.actions.view_more}
          </Link>
        </PrivateInquriyComp>
      </Col>
      <Col lg='6' md='12' sm='12' className='my-3'>
        <PublicInquriyComp
          showDate={false}
          cardTitle={statsTranslate.recently_added_public_inquiry}
          isLoading={publicInquiriesIsLoading}
          items={publicInquiries}
          edit='/my-public-inquiries-supplier'
        >
          <Link to='/my-public-inquiries-supplier' className='btn btn-primary'>
            {getLangData().components.actions.view_more}
          </Link>
        </PublicInquriyComp>
      </Col> */}
    </Row>
  );
  return (
    <>
      <Stats
        title={statsTranslate.today}
        sections={[
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.public_proposals,
            item: {
              title: statsTranslate.proposal,
              count: supplierStats?.today?.publicProposals
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.public_inquiries,
            item: {
              title: statsTranslate.inquiry,
              count: supplierStats?.today?.publicInquiries
            }
          },
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.private_inquiries,
            item: {
              title: statsTranslate.proposal,
              count: supplierStats?.today?.privateProposals
            }
          }
        ]}
      />
      <AdBanner />
      <Stats
        title={statsTranslate.total}
        sections={[
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.public_proposals,
            item: {
              title: statsTranslate.proposal,
              count: supplierStats?.total?.publicProposals
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.public_inquiries,
            item: {
              title: statsTranslate.inquiry,
              count: supplierStats?.total?.publicInquiries
            }
          },
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.private_inquiries,
            item: {
              title: statsTranslate.proposal,
              count: supplierStats?.total?.privateProposals
            }
          }
        ]}
      />
      <AdBanner />
    </>
  );
};
const mapStateToProps = (state, props) => {
  return {
    supplierStats: state.stats.supplierStats,
    currentUser: state.users.currentUser,
    supplierProducts: supplierProductsSelector(state),
    supplierProductsIsLoading: supplierProductsIsLoadingSelector(state),
    supplierData: supplierDataSelector(state),
    privateInquiries: supplierPrivateInquiriesSelector(state),
    privateInquiriesIsLoading: supplierPrivateInquiriesIsLoadingSelector(state),
    publicInquiries: supplierPublicInquiriesSelector(state),
    publicInquiriesIsLoading: supplierPublicInquiriesIsLoadingSelector(state)
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    //   getSuppliers: getSuppliersAction,
    getSupplierStatsAction,
    getSupplierProducts: getMyProductsSuppliersAction,
    getPrivateInquiries: getMySupplierPrivateInquiriesAction,
    getPublicInquiries: getMySuppliersPublicInquiriesAction
  })(SupplierStaticBar)
);
